module.exports = __webpack_public_path__ + "files/29249d3bc8e16bb8fb43cb55abdb6a5c.svg";